import React, { useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import ProductCard from './ProductCard';

const ProductCarousel = ({ title, subtitle, products, alwaysShowButtons = false }) => {
  const ref = useRef(null);

  const scroll = (dir) => {
    if (!ref.current) return;
    const w = ref.current.clientWidth;
    ref.current.scrollBy({ left: dir * w * 0.8, behavior: 'smooth' });
  };

  return (
    <section className="max-w-7xl mx-auto px-4 py-14">
      <div className="flex items-end justify-between mb-8 gap-4">
        <div>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1F2A44]">{title}</h2>
          {subtitle && <p className="mt-2 text-[#1F2A44]/70 max-w-2xl text-sm md:text-base">{subtitle}</p>}
          <span className="inline-block mt-3 h-[2px] w-16 bg-[#E8B530]"></span>
        </div>
        <div className={`${alwaysShowButtons ? 'flex' : 'hidden md:flex'} gap-2`}>
          <button onClick={() => scroll(-1)} aria-label="prev" className="w-10 h-10 rounded-full border border-[#1F2A44]/20 hover:bg-[#E8B530] hover:border-[#E8B530] flex items-center justify-center text-[#1F2A44] transition-colors">
            <ChevronLeft size={18} />
          </button>
          <button onClick={() => scroll(1)} aria-label="next" className="w-10 h-10 rounded-full border border-[#1F2A44]/20 hover:bg-[#E8B530] hover:border-[#E8B530] flex items-center justify-center text-[#1F2A44] transition-colors">
            <ChevronRight size={18} />
          </button>
        </div>
      </div>

      <div className="relative">
        <div ref={ref} className="flex gap-4 md:gap-6 overflow-x-auto snap-x scroll-smooth no-scrollbar pb-2">
          {products.map((p) => (
            <div key={p.id} className="snap-start flex-shrink-0 w-[68vw] sm:w-[44vw] md:w-1/3 lg:w-1/3">
              <ProductCard product={p} />
            </div>
          ))}
        </div>

        <button onClick={() => scroll(-1)} aria-label="prev" className={`${alwaysShowButtons ? 'flex' : 'hidden md:flex'} absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1/2 z-30 w-12 h-12 rounded-full border border-[#1F2A44]/20 bg-white/95 hover:bg-[#E8B530] hover:border-[#E8B530] items-center justify-center text-[#1F2A44] transition-colors shadow-lg`}>
          <ChevronLeft size={20} />
        </button>
        <button onClick={() => scroll(1)} aria-label="next" className={`${alwaysShowButtons ? 'flex' : 'hidden md:flex'} absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 z-30 w-12 h-12 rounded-full border border-[#1F2A44]/20 bg-white/95 hover:bg-[#E8B530] hover:border-[#E8B530] items-center justify-center text-[#1F2A44] transition-colors shadow-lg`}>
          <ChevronRight size={20} />
        </button>
      </div>
    </section>
  );
};

export default ProductCarousel;
